var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center-left"},[_c('el-menu',{staticClass:"left-menu",attrs:{"default-active":_vm.defaultActive,"mode":"vertical"},on:{"select":_vm.handleMenuSelect}},_vm._l((_vm.menuList),function(menu){return _c('el-menu-item',{key:menu.index,attrs:{"index":menu.index}},[_vm._v("\n            "+_vm._s(menu.label)+"\n        ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }